import Analytics from "./js/Analytics";
import Accessibility from "./js/Accessibility";


(() => {
    Analytics.init();
    Accessibility.init();
})()